// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c456e2aa","453":"50ef59f0","732":"0431b4b0","977":"71cbd8c8"}[chunkId] + ".chunk.js";
};